'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

interface FilterPillProps {
  selectedOptions: string[];
  handleClearFilters: (e: React.MouseEvent) => void;
}

const FilterPill = ({ selectedOptions, handleClearFilters }: FilterPillProps) => {
  return (
    <div className="flex items-center max-h-6 pl-2 rounded-full bg-neutral-200 whitespace-nowrap">
      <span className="text-sm font-medium text-neutral-800 leading-normal">
        {selectedOptions.length} Filter
        {selectedOptions.length > 1 ? 's' : ''}
      </span>
      <span
        role="button"
        tabIndex={0}
        onClick={handleClearFilters}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClearFilters(e as unknown as React.MouseEvent);
          }
        }}
        className="p-1 rounded-full hover:bg-neutral-300 transition-colors cursor-pointer"
        aria-label="Clear Filters"
      >
        <Icon icon={faXmark} className="h-3.5 w-3.5 text-neutral-600" />
      </span>
    </div>
  );
};

export default FilterPill;
